import type {
  RequestAttachment,
  RequestComment,
  RequestWorkspaceDetail,
} from "../../domain/models";

export type RequestWorkspaceRepository = {
  get(requestNo: string): Promise<RequestWorkspaceDetail>;
  addComment(requestNo: string, body: string): Promise<RequestComment>;
  uploadAttachment(requestNo: string, file: File): Promise<RequestAttachment>;
};

export function createRequestWorkspaceService(
  repository: RequestWorkspaceRepository,
) {
  return {
    load: (requestNo: string) => repository.get(requestNo),
    addComment: (requestNo: string, body: string) =>
      repository.addComment(requestNo, body.trim()),
    uploadAttachment: (requestNo: string, file: File) => {
      if (file.size > 20 * 1024 * 1024) {
        return Promise.reject(new Error("Belge en fazla 20 MB olabilir."));
      }
      return repository.uploadAttachment(requestNo, file);
    },
  };
}

export type RequestWorkspaceService = ReturnType<
  typeof createRequestWorkspaceService
>;
